'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var addProductsToolbar = exports.addProductsToolbar = {
    template: require('./add-products-toolbar.html'),
    bindings: {
        product: '=',
        addingProducts: '<',
        productsQuantityChanged: '<',
        addToCart: '&',
        isOpen: '<',
        productsAdded: '<',
        hasError: '<'
    },
    controllerAs: 'vm',
    controller: function addProductsToolbarController() {
        'ngInject';
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/product/components/add-products-toolbar.js
// module id = 960
// module chunks = 0